export function formatPrice(price?: number | null): string {
  if (!price) {
    return '';
  }

  let formattedPrice = price.toFixed(2).toString();
  formattedPrice = 'R$ ' + formattedPrice.replace('.', ',');
  return formattedPrice;
}
